import i18n from "i18next";
import HttpBackend from "i18next-http-backend";
import { initReactI18next } from "react-i18next";
import { LANGUAGE_STORAGE_KEY } from "~/shared/config/i18n.constants";
import { readString } from "~/shared/lib/storage";

const SUPPORTED_LNGS = ["en", "ru"];
const NS = [
    "common",
    "auth",
    "dashboard",
    "home",
    "workspace",
    "ui",
    "project",
    "profile",
    "admin",
    "landing",
    "sidebar",
    "chat",
    "chat-settings",
    "settings",
    "projects",
    "chats",
    "assets",
    "generations",
    "elements",
];

i18n.use(HttpBackend).use(initReactI18next);

const savedLang = readString(LANGUAGE_STORAGE_KEY);
const browserLang = typeof navigator !== "undefined" ? navigator.language.slice(0, 2) : "en";
const initialLng = SUPPORTED_LNGS.includes(savedLang ?? "")
    ? savedLang!
    : SUPPORTED_LNGS.includes(browserLang)
      ? browserLang
      : "en";

void i18n.init({
    lng: initialLng,
    fallbackLng: "en",
    supportedLngs: SUPPORTED_LNGS,
    ns: NS,
    defaultNS: "common",
    interpolation: { escapeValue: false },
    backend: { loadPath: "/locales/{{lng}}/{{ns}}.json" },
    react: { useSuspense: false },
});

export default i18n;
